<template>
  <div id="modalTermOfUseModal" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Termos de Uso e Adesão</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div class="modal-body pb-0">
          <embed :src="termUse" frameborder="0" width="100%" height="380px" />
        </div>
        <div class="modal-footer border-top-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal } from '@/utils/modal'

export default {
  name: 'TermOfUseModal',

  computed: {
    termUse() {
      return `${process.env.VUE_APP_BASE_URL_API}/uploads/term/TERMOS_DE_USO_E_ADESAO.pdf`
    },
  },

  mounted() {
    showModal('modalTermOfUseModal')
  },
}
</script>
